import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=fb89abf0&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=ts"
export * from "./ErrorPage.vue?vue&type=script&lang=ts"
import style0 from "./ErrorPage.vue?vue&type=style&index=0&id=fb89abf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb89abf0",
  null
  
)

export default component.exports